(function() {
  var isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initSocialFeed(section) {
    var track = section.querySelector('.social-feed__track');
    if (!track) return;
    var prevBtn = section.querySelector('[data-sf-prev]');
    var nextBtn = section.querySelector('[data-sf-next]');
    var sfDiv = section.querySelector('.social-feed') || section;
    var autoplayMs = parseInt(sfDiv.dataset.sfAutoplay || '0', 10);
    var timer = null;
    var slides = track.querySelectorAll('.social-feed-slide');

    function getSlideWidth() {
      var slide = slides[0];
      if (!slide) return 0;
      return slide.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 12);
    }

    function scrollNext() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      }
    }
    function scrollPrev() {
      if (track.scrollLeft <= 2) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      }
    }

    function resetTimer() {
      clearInterval(timer);
      if (autoplayMs > 0) timer = setInterval(scrollNext, autoplayMs);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { scrollPrev(); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { scrollNext(); resetTimer(); });

    track.addEventListener('pointerdown', function() { clearInterval(timer); });
    track.addEventListener('pointerup', function() { if (autoplayMs > 0) resetTimer(); });

    resetTimer();

    // Mute/unmute buttons
    section.querySelectorAll('.social-feed-slide__sound').forEach(function(btn) {
      var slide = btn.closest('.social-feed-slide');
      var video = slide && slide.querySelector('video');
      if (!video) return;
      video.muted = true;
      btn.classList.add('is-muted');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        video.muted = !video.muted;
        btn.classList.toggle('is-muted', video.muted);
      });
    });

    // Desktop: play on hover, pause on leave
    // Mobile: play when visible via IntersectionObserver
    if (isHoverDevice) {
      section.querySelectorAll('.social-feed-slide').forEach(function(slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        video.muted = true;
        slide.addEventListener('mouseenter', function() {
          video.play().catch(function() {});
        });
        slide.addEventListener('mouseleave', function() {
          video.pause();
          video.currentTime = 0;
        });
      });
    } else if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      section.querySelectorAll('.social-feed-slide video').forEach(function(video) {
        video.muted = true;
        videoObserver.observe(video);
      });
    } else {
      section.querySelectorAll('.social-feed-slide video').forEach(function(video) {
        video.muted = true;
        video.play().catch(function() {});
      });
    }
  }

  document.querySelectorAll('.social-feed-section').forEach(initSocialFeed);
  document.addEventListener('shopify:section:load', function(e) {
    var el = e.target.querySelector('.social-feed-section') || e.target;
    initSocialFeed(el);
  });
})();